<template>
    <div
        v-gtm:type="'Matches'"
        v-gtm:@view
        class="tournamentMatches"
    >
        <NavbarBlock gtmTypePrefix="Matches" />
        <TwoSubBetParlayBanner v-if="isMixParlay && isMpTwoSubBetEnabled" />
        <MaxPayout v-if="isShowMpMaxPayout" />
        <component
            v-bind:is="oddsDisplayComponent"
            v-if="oddsDisplayComponent"
            v-bind:key="oddsDisplayComponentKey"
        />

        <EFootballOddsDisplayBlock
            v-if="isEFootballInTournamentCenterEnabled"
            v-bind:key="eFootballOddsKey"
        />
    </div>
</template>

<script lang="ts" setup>
    import { storeToRefs } from 'pinia';
    import { computed } from 'vue';
    import TwoSubBetParlayBanner from '@/components/event/TwoSubBetParlayBanner.vue';
    import MaxPayout from '@/components/maxPayout/MaxPayout.vue';
    import NavbarBlock from '@/components/navbarBlock/NavbarBlock.Asia.vue';
    import OddsDisplayBlock from '@/components/oddsDisplay/OddsDisplayBlock.vue';
    import OutrightOddsDisplayBlock from '@/components/oddsDisplay/outright/OutrightOddsDisplayBlock.vue';
    import { MarketPage, SiteStyle } from '@/interface/enum';
    import { useAsiaSportMarketInfoStore } from '@/store/asiaSportMarketInfoStore';
    import { useOddsDisplaySettingsStore } from '@/store/oddsDisplaySettingsStore';
    import { useToggleStore } from '@/store/toggleStore';
    import EFootballOddsDisplayBlock from '@/views/tournamentCenter/EFootballOddsDisplayBlock.vue';

    const { oddsDisplayMode } = storeToRefs(useOddsDisplaySettingsStore());
    const { promotionZone, sportType, marketPage, eventDate, isMixParlay } = storeToRefs(useAsiaSportMarketInfoStore());
    const oddsDisplayComponent = computed(() => {
        const doubleLineMarketPages = [
            MarketPage.Live,
            MarketPage.Today,
            MarketPage.EarlyMarket,
            MarketPage.MixParlay,
            MarketPage.MyFavorites,
            MarketPage.All,
        ];
        if (doubleLineMarketPages.includes(marketPage.value)) {
            return OddsDisplayBlock;
        }
        if (marketPage.value === MarketPage.Outright) {
            return OutrightOddsDisplayBlock;
        }
        return null;
    });
    const isShowMpMaxPayout = computed(() => marketPage.value === MarketPage.MixParlay);

    const oddsDisplayComponentKey = computed(() => `${promotionZone.value}_${sportType.value}_${marketPage.value}_${eventDate.value}_${oddsDisplayMode.value}`);

    const { isMpTwoSubBetEnabled, isEFootballInTournamentCenterEnabled } = storeToRefs(useToggleStore(SiteStyle.Asia));

    const eFootballOddsKey = computed(() => `${marketPage.value}_${eventDate.value}`);
</script>
